module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GYZ.d1f3a413.tom";